if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event('change', { bubbles: true });

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      this.input = this.input || this.querySelector('input');
      const previousValue = this.input.value;

      event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);
}

document.querySelectorAll('.prevent-hashjump').forEach((link) => {
  link.addEventListener('click', (e) => {
    const hashtag = e.target.href.split('#');
    if (hashtag[1]) {
      const targetElem = document.querySelector('#' + hashtag[1]);
      if (targetElem) {
        const scrollTop = window.pageYOffset;

        window.scrollTo({ top: scrollTop });
        setTimeout(function () {
          window.scrollTo({ top: scrollTop });
        }, 1);
      }
    }
  });
});

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt2 = document.createElement('option');
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// REVIUM: 11/25 - Update all theme cart icon bubbles to match current cart
window.updateThemeCartBubblesFromCart = function () {
  console.log('[updateThemeCartBubblesFromCart] called');

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const count = cart.item_count;
      console.log('[updateThemeCartBubblesFromCart] /cart.js item_count =', count);

      const bubbles = document.querySelectorAll('cart-icon-bubble');
      console.log('[updateThemeCartBubblesFromCart] bubbles found =', bubbles.length);
      if (!bubbles.length) return;

      bubbles.forEach((bubbleRoot, index) => {
        const countWrapper = bubbleRoot.querySelector('.cart-icon-bubble__count');
        const countEl = bubbleRoot.querySelector('.cart-count');

        if (!countWrapper || !countEl) {
          console.warn(`[updateThemeCartBubblesFromCart] missing elements in bubble #${index}`);
          return;
        }

        //console.log(`[updateThemeCartBubblesFromCart] updating bubble #${index} to`, count);
        countEl.textContent = count;

        if (count === 0) {
          countWrapper.classList.add('hidden');
        } else {
          countWrapper.classList.remove('hidden');
        }
      });
    })
    .catch((error) => {
      console.error('Error updating theme cart bubbles from /cart.js:', error);
    });
};